// extracted by mini-css-extract-plugin
module.exports = {"spendings":"Spendings_spendings__hfrvb","inner":"Spendings_inner__3rwuW","spendingsTotal":"Spendings_spendingsTotal__3P1ty"};